var React = require('react');

function LetterRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M65.717,1.945L64.985,0H0v110.178l36.059,117.438H0v85.553h61.475L79.881,373.9h125.604L65.717,1.945z M65.926,307.168H0\r\n\tv-73.553h44.178L0,89.825V6h60.831l135.989,361.9H84.332L65.926,307.168z"}));
}

LetterRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"205.484px","height":"373.9px","viewBox":"0 0 205.484 373.9","enableBackground":"new 0 0 205.484 373.9","xmlSpace":"preserve"};

module.exports = LetterRight;

LetterRight.default = LetterRight;
